import { createAction, props } from '@ngrx/store';
import { FilterStorageState, TableContext } from './filter.reducer';

export enum FilterActionType {
  ResetFilter = '[Filter Storage] Filter Reset',
  SetFilter = '[Filter Storage] Set Filter',
  InitHiddenColumns = '[Filter Storage] Init hidden columns',
  InitHiddenColumnsSuccess = '[Filter Storage] Init hidden columns success',
  UpdateHiddenColumns = '[Filter Storage] Update hidden columns',
  UpdateHiddenColumnsSuccess = '[Filter Storage] Update hidden columns success',
}

export const resetFilter = createAction(
  FilterActionType.ResetFilter,
  props<{
    key: TableContext;
    defaultFilter?: Record<string, string[]>;
    defaultSort?: { sortField: string; sortOrder: 'asc' | 'desc' };
  }>()
);

export const setFilter = createAction(
  FilterActionType.SetFilter,
  props<{ key: TableContext; filter: FilterStorageState }>()
);

export const initHiddenColumns = createAction(FilterActionType.InitHiddenColumns);

export const initHiddenColumnsSuccess = createAction(
  FilterActionType.InitHiddenColumnsSuccess,
  props<{ hiddenColumnsConfig: Record<TableContext, string[]> }>()
);

export const updateHiddenColumns = createAction(
  FilterActionType.UpdateHiddenColumns,
  props<{ tableContext: TableContext; hiddenColumns: string[] }>()
);

export const updateHiddenColumnsSuccess = createAction(
  FilterActionType.UpdateHiddenColumnsSuccess,
  props<{ tableContext: TableContext; hiddenColumns: string[] }>()
);
